import Typography from '@mui/material/Typography';
import { formatNextEventDate } from '@/utils/format-next-event-date';
import type { Group } from '@/types/Group';

interface Props {
  group: Group;
}

export default function GroupListActivityInfo({ group }: Props) {
  const nextDateLabel = group.nextEventStartAt
    ? formatNextEventDate(group.nextEventStartAt)
    : null;
  const count = group.upcomingEventsCount || 0;
  const membersCount = group.membersCount;

  const parts: string[] = [];

  if (membersCount != null) {
    parts.push(`👥 ${membersCount} ${membersCount === 1 ? 'member' : 'members'}`);
  }

  if (nextDateLabel) {
    parts.push(`📅 Next: ${nextDateLabel}`);
  }

  if (count > 1) {
    parts.push(`${count} upcoming`);
  } else if (count === 1 && !nextDateLabel) {
    parts.push('1 upcoming ride');
  }

  if (parts.length === 0) {
    return null;
  }

  return (
    <Typography variant="body2" color="text.secondary">
      {parts.join(' · ')}
    </Typography>
  );
}
